// function apiUriHttp() {
//   return "http://localhost:7006/api/testing";
// }

// const KeycloakAutUrl = window.plasma.environment.KeycloakAutUrl;
// const KeycloakRealm = window.plasma.environment.KeycloakRealm || '';
// const KeycloakClient = window.plasma.environment.KeycloakClient || '';
// const serverIP = window.plasma.environment.serverIP;
// const serverIP2 = window.plasma.environment.serverIP2;

//AWS API Config
const KeycloakAutUrl = "https://auth.wearmanager.sms-group.tech";
// const KeycloakAutUrl = "https://localhost:8071";
const KeycloakRealm = "wearmanager";
const KeycloakClient = "consumables-manager-fe";
const serverIP = "https://consumables-api.wearmanager.sms-group.tech/api/";
// const serverIP = "http://localhost:8080/api/";
// const serverIP = "https://localhost:8081/api/";
const serverIP2 = "https://consumables-startup.wearmanager.sms-group.tech/api/";
// const serverIP2 = "http://localhost:7016/api/";

function apiUriHttp() {
  return `${serverIP}AppUsers/`;
}

function apiUriHttps() {
  return `${serverIP}AppUsers/`;
}
function apiUriProjHttp() {
  return `${serverIP}AppStartup/`;
}
function apiUriProj2Http() {
  return `${serverIP2}AppStartup/`;
}
function apiUriProj2Https() {
  return `${serverIP2}AppStartup/`;
}
function apiUriProjHttps() {
  return `${serverIP}AppStartup/`;
}
function apiUriExcelHttp() {
  return `${serverIP}AppFile/`;

}
function apiUriExcelHttps() {
  return `${serverIP}AppFile/`;
}
function apiUriMasterDataHttp() {
  return `${serverIP}MasterData/`;
}
function apiUriDesignDrawingsHttp() {
  return `${serverIP}DesignDrawings/`;
}
function apiUriRfqActionHttp() {
  return `${serverIP}RfqAction/`;
}
function apiUriGuideDataHttp() {
  return `${serverIP}GuideData/`;
}
function apiUriConsumableDataHttp() {
  return `${serverIP}ConsumableData/`;
}
function apiUriCartDataHttp() {
  return `${serverIP}CartData/`;
}
function apiUriPersonnelHttp() {
  return `${serverIP}Personnel/`;
}
function apiUriProductionPlanHttp() {
  return `${serverIP}ProductionPlan/`;
}
function apiUriProductFamilyHttp() {
  return `${serverIP}ProductFamily/`;
}

export {
  apiUriHttp, apiUriHttps,
  apiUriProjHttp, apiUriProjHttps,
  apiUriProj2Http, apiUriProj2Https,
  apiUriExcelHttp, apiUriExcelHttps,
  apiUriMasterDataHttp,
  apiUriDesignDrawingsHttp,
  apiUriRfqActionHttp,
  apiUriGuideDataHttp,
  apiUriConsumableDataHttp,
  apiUriCartDataHttp,
  apiUriPersonnelHttp,
  apiUriProductionPlanHttp,
  apiUriProductFamilyHttp,
  KeycloakAutUrl,
  KeycloakRealm,
  KeycloakClient
};
